import * as Environment from "../base/Environment.js";

import {AnimatableSprite} from "../base/Display2D.js";

import {SiteSection} from "./SiteSection.js";

//
// SystemStructure extends SiteSection
//

export const SystemStructure = function (context) {
	SiteSection.apply (this, arguments);
	
};

SystemStructure.IS_IN_NEOS_EDITOR = /* Environment.FAST_PASS || */ Environment.IS_IN_NEOS_EDITOR;

window.SystemStructure = SystemStructure;

SystemStructure.prototype = Object.create (SiteSection.prototype);

SystemStructure.prototype.takeElement = function (element) {
	SiteSection.prototype.takeElement.apply (this, arguments);
	
	const menuBar = element.querySelector (".system-structure-menu-bar");
	const menuBarItems = this.menuBarItems = new Array ();
	
	const visuals = this.visuals = element.querySelectorAll (".system-structure-visual");
	
	const details = this.details = element.querySelectorAll (".system-structure-detail");
	details.forEach ((detail, index) => {
		const labelText = detail.dataset.label;
		
		detail.style.setProperty ("--counter", "\"" + labelText + "\"");
		
		const productLinks = document.createElement ("div");
		productLinks.classList.add ("system-structure-detail-links");
		
		this.populateProductLinks (productLinks, detail, index);
		
		detail.insertBefore (
			productLinks,
			detail.querySelector (".system-structure-detail-text").nextElementChild
			
		);
		
		const menuBarItem = document.createElement ("div");
		
		menuBarItem.textContent = labelText;
		menuBarItem.addEventListener ("click", event => this.selectItemByIndex (index));
		
		menuBar.appendChild (menuBarItem);
		menuBarItems.push (menuBarItem);
		
	});
	
	if (SystemStructure.IS_IN_NEOS_EDITOR) {
		var mutationObserver = new MutationObserver (this.mutateProduct.bind (this));
		mutationObserver.observe (element.querySelector (".system-structure-details"), {
			subtree: true,
			characterData: true,
			childList: true
			
		});
		
	}
	
	this.selectItemByIndex (Environment.FAST_PASS ? 0 : 0);
	
	if (Environment.FAST_PASS) {
		window.setTimeout (_ => {
			// this.selectItemByIndex (3);
			
		}, 500);
		
	}
	
};

SystemStructure.prototype.populateProductLinks = function (productLinks, detail, index) {
	detail.querySelectorAll (".system-structure-detail-product").forEach (product => {
		const title = product.querySelector (".system-structure-detail-product-title");
		const productLink = document.createElement ("div");
		
		productLink.textContent = title.textContent;
		productLink.addEventListener ("click", event => this.selectItemByIndex (index));
		
		productLinks.appendChild (productLink);
		
	});
	
};

SystemStructure.prototype.mutateProduct = function (entries) {
	if (this.isMutating)
		return;
	
	let isProductAffected;
	
	const affectedNodes = [];
	entries.forEach (entry => {
		affectedNodes.push (...entry.addedNodes);
		affectedNodes.push (...entry.removedNodes);
		
		if (entry.type == "characterData") {
			let node = entry.target;
			while (node = node.parentNode) {
				if (node.classList.contains ("system-structure-detail-product")) {
					isProductAffected = true;
					break;
					
				}
				
			}
			
		}
		
	});
	
	affectedNodes.forEach (node => {
		if (node.classList.contains ("system-structure-detail-product"))
			isProductAffected = true;
		
	});
	
	if (!isProductAffected)
		return;
	
	this.isMutating = true;
	
	const element = this.element;
	this.details.forEach ((detail, index) => {
		const productLinks = detail.querySelector (".system-structure-detail-links");
		productLinks.innerHTML = "";
		
		this.populateProductLinks (productLinks, detail, index);
		
	});
	
	this.isMutating = false;
	
};

SystemStructure.prototype.awake = function () {
	SiteSection.prototype.awake.apply (this, arguments);
	
};

SystemStructure.prototype.sleep = function () {
	SiteSection.prototype.sleep.apply (this, arguments);
	
};

SystemStructure.prototype.selectItemByIndex = function (index) {
	this.menuBarItems.forEach ((menuBarItem, i) => {
		menuBarItem.classList.toggle ("active", i == index);
		
	});
	
	const details = this.details;
	const illustrationSrc = details [index].dataset.illustrationSrc;
	
	this.visuals.forEach (visual => {
		let image = visual.firstElementChild;
		if (!image)
			visual.appendChild (image = new Image ());
		
		image.src = illustrationSrc;
		
	});
	
	this.openDetail (index && details [index]);
	
};

SystemStructure.prototype.openDetail = function (detail) {
	if (detail == this.detail)
		return;
	
	const element = this.element;
	this.startHeight = element.offsetHeight;
	
	let resizeObserver = this.resizeObserver;
	if (!resizeObserver)
		resizeObserver = this.resizeObserver = new ResizeObserver (this.resizeDetail.bind (this));
	
	const lastDetail = this.detail;
	if (lastDetail) {
		const overlay = lastDetail.overlay;
		resizeObserver.unobserve (overlay);
		
		if (SystemStructure.IS_IN_NEOS_EDITOR)
			overlay.classList.remove ("overlay");
		
		lastDetail.parentNode.style.minHeight = "";
		
	}
	
	this.detail = detail;
	
	if (detail) {
		let overlay = detail.overlay;
		
		if (!overlay) {
			if (SystemStructure.IS_IN_NEOS_EDITOR) {
				overlay = detail.overlay = detail;
				
			} else {
				overlay = detail.overlay = detail.cloneNode (true);

				overlay.querySelectorAll (".system-structure-detail-product").forEach (product => {
					const title = product.querySelector (".system-structure-detail-product-title");
					title.addEventListener ("click", event => window.open (product.dataset.productUrl));
					
				});
				
			}
			
			const closeButton = document.createElement ("div");
			closeButton.classList.add ("close-button");
			closeButton.addEventListener ("click", event => this.selectItemByIndex (0));
			overlay.appendChild (closeButton);
			
		}
		
		overlay.classList.add ("overlay");
		this.currentOverlay = overlay;
		
		if (detail !== overlay)
			detail.parentNode.appendChild (overlay);
		
		overlay.style.zIndex = ++SystemStructure.overlayZIndex;
		
		this.resizeDetail ();
		
	
		resizeObserver.observe (overlay);
		
		if (!SystemStructure.IS_IN_NEOS_EDITOR)
			this.startAnimation ("FadeInOverlay", {direction: 1, rate: .2, phase: 0});
		
	} else {
		this.minHeight = "";
		if (!SystemStructure.IS_IN_NEOS_EDITOR)
			this.startAnimation ("FadeInOverlay", {direction: 0, rate: .2, phase: 1});
		
	}
	
	if (!SystemStructure.IS_IN_NEOS_EDITOR) {
		element.style.height = "";
		this.targetHeight = element.offsetHeight;
		
		this.startAnimation ("Height", {direction: 1, rate: .03, phase: 0});
		
	}
	
};

SystemStructure.overlayZIndex = 1;

SystemStructure.prototype.animateFadeInOverlay = function () {
	const state = this.updatedState ("FadeInOverlay");
	const t = state.phase;
	
	const currentOverlay = this.currentOverlay;
	if (!currentOverlay)
		return;
	
	currentOverlay.style.opacity = t;
	
	const overlays = this.element.querySelectorAll (".overlay");
	
	if (t == 1) {
		overlays.forEach (overlay => {
			if (overlay != currentOverlay)
				overlay.remove ();
			
		});
		
	} else if (t == 0) {
		overlays.forEach (overlay => {
			overlay.remove ();
			
		}); 
		
	}
	
};

SystemStructure.prototype.resizeDetail = function (entries) {
	if (this.isResizing)
		return;
	
	this.isResizing = true;
	
	const detail = this.detail;
	
	const offsetHeight = detail.overlay.offsetHeight;
	detail.parentNode.style.minHeight = offsetHeight + "px";
	
	this.isResizing = false;
	
};

SystemStructure.prototype.animateHeight = function () {
	const state = this.updatedState ("Height");
	let t = 1 - state.phase;
	t = 1 - t * t * t;
	t = .5 - Math.cos (t * Math.PI) * .5;
	
	const element = this.element;
	element.style.height = t == 1 ? "" :
		(1 - t) * this.startHeight + t * this.targetHeight + "px";
	
};
